import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class SingleNotification extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'SingleNotification';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            eventGuestId: null,
            title: null,
            content: null,
            scheduledAt: null,
            sentAt: null,
        }
    }
}

const servicePath = 'single-notification';
const servicePlugin = makeServicePlugin({
    Model: SingleNotification,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin
